import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import { LINKS } from "../../lib/content";
import { trackEvent } from "../../lib/analytics";

export const Footer = () => (
  <footer className="relative bg-[#050505] border-t border-white/10 overflow-hidden grain">
    <div className="max-w-7xl mx-auto px-5 lg:px-8 pt-16 pb-8">
      <div className="grid md:grid-cols-3 gap-10 mb-16">
        <div>
          <p className="eyebrow mb-4">The Standard</p>
          <p className="text-zinc-400 text-sm leading-relaxed max-w-xs">
            HYROX training built with Dallas Performance Systems, co-signed by
            NinjAthlete. 8 runs. 8 stations. One standard — Dallas, TX.
          </p>
        </div>
        <div>
          <p className="eyebrow mb-4">Navigate</p>
          <div className="flex flex-col gap-2">
            {[
              ["/stations", "Format & Stations"],
              ["/simulation", "Full Simulation"],
              ["/schedule", "Schedule & Booking"],
              ["/program", "12-Week Program"],
              ["/events", "Events List"],
              ["/results", "Leaderboard"],
              ["/videos", "Video Vault"],
              ["/merch", "Co-Branded Merch"],
              ["/gear", "Race-Standard Gear"],
              ["/blog", "Blog"],
              ["/support", "Support the Program"],
            ].map(([to, label]) => (
              <Link key={to} to={to} data-testid={`footer-link-${to.slice(1)}`} className="font-head uppercase text-lg text-zinc-300 hover:text-volt transition-colors w-fit">
                {label}
              </Link>
            ))}
          </div>
        </div>
        <div>
          <p className="eyebrow mb-4">Connect</p>
          <div className="flex flex-col gap-3">
            <Link to="/events" data-testid="footer-book-link" className="inline-flex items-center gap-2 text-zinc-300 hover:text-volt transition-colors text-sm font-mono2 uppercase tracking-wider w-fit" onClick={() => trackEvent("booking_click", { placement: "footer", service: "general" })}>
              Book a Session <ArrowRight size={14} />
            </Link>
            <a href={LINKS.ninjathlete} target="_blank" rel="noreferrer" data-testid="footer-ninjathlete-link" className="inline-flex items-center gap-2 text-zinc-300 hover:text-volt transition-colors text-sm font-mono2 uppercase tracking-wider w-fit">
              NinjAthlete <ArrowUpRight size={14} />
            </a>
          </div>
        </div>
      </div>

      <div className="select-none pointer-events-none" aria-hidden="true">
        <p className="font-head font-black uppercase leading-none text-outline whitespace-nowrap" style={{ fontSize: "clamp(4rem, 13vw, 12rem)" }}>
          HYROXNINJA
        </p>
      </div>

      <div className="flex flex-col sm:flex-row justify-between gap-2 pt-6 border-t border-white/10 mt-4">
        <p className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-zinc-600">
          © {new Date().getFullYear()} hyroxninja.com — Dallas 214
        </p>
        <p className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-zinc-600">
          Hyrox Ninja × Dallas Performance Systems · Not affiliated with HYROX GmbH
        </p>
      </div>
    </div>
  </footer>
);
